import { createContext, useContext } from "react";
import type { BusinessOnboarding } from "./types";

export const OnboardingStateContext = createContext<
  BusinessOnboarding | undefined
>(undefined);
export const useOnboardingState = () => useContext(OnboardingStateContext);
